module.exports = ol.layer.Group;